import styled from 'styled-components'
import Footer from '../../components/footer/Footer'
import Header from '../../components/header/Header'
import { BiomarkersContainer, Container, Title } from '../recommendations/Recommendations'
import MeasuredBiomarkers from '../../components/measuredBiomarkers/MeasuredBiomarkers'
import AboutBiomarker from '../../components/modals/AboutBiomarker'
import { useNavigate } from 'react-router-dom'

const Block = styled.div`
  /* margin-top: 60px; */
  width: 100%;
`

const Main = () => {
    return (<div style={{maxWidth: '800px', margin: '0 auto'}}>
            <h1>Privacy Policy</h1>

            <h2>1. Introduction</h2>
            <p>At Swiss Medical Laboratory, we prioritize the privacy of our users. This policy outlines our data collection, processing, usage, and protection practices.</p>

            <h2>2. Definitions</h2>
            <ul>
                <li><strong>Personal Data:</strong> Information that identifies an individual or can be used to identify an individual.</li>
                <li><strong>Processing:</strong> Any action or set of actions performed on personal data, whether automated or manual.</li>
                <li><strong>Consent:</strong> A clear and informed agreement by users for processing their personal data.</li>
            </ul>

            <h2>3. Data Collection</h2>
            <p>We collect personal data when:</p>
            <ul>
                <li>You register for an account or use our services.</li>
                <li>You voluntarily provide information, like through a contact form.</li>
                <li>You submit samples for testing or analysis.</li>
            </ul>

            <h2>4. Data Usage</h2>
            <p>Your data is used for:</p>
            <ul>
                <li>Providing, improving, and personalizing our services.</li>
                <li>Communication regarding services or updates.</li>
                <li>Legal compliance and addressing disputes.</li>
                <li>Research purposes, with personal identifiers removed.</li>
            </ul>

            <h2>5. Data Sharing</h2>
            <p>We do not sell your personal data. We might share data with:</p>
            <ul>
                <li>Medical professionals for diagnostic or treatment purposes.</li>
                <li>Third parties when legally obliged.</li>
                <li>Service providers, under strict data protection agreements.</li>
            </ul>

            <h2>6. Data Retention</h2>
            <p>We retain your personal data as long as necessary to fulfill the purposes for which it was collected, or as required by law.</p>

            <h2>7. Data Security</h2>
            <p>We employ strict security measures to protect your data against unauthorized access, alteration, disclosure, or destruction.</p>

            <h2>8. User Rights</h2>
            <p>You have the right to:</p>
            <ul>
                <li>Access the personal data we hold about you.</li>
                <li>Correct inaccuracies in your data.</li>
                <li>Withdraw consent for data processing.</li>
                <li>Request deletion of your data, under certain conditions.</li>
            </ul>

            <h2>9. Cookies and Tracking</h2>
            <p>We may use cookies and similar technologies to improve user experience, for analytics, and for advertising purposes. Users can manage or decline cookies in their browser settings.</p>

            <h2>10. Third-Party Links</h2>
            <p>Our services might link to external sites. We are not responsible for the privacy practices of these sites.</p>

            <h2>11. Children's Privacy</h2>
            <p>Our services are not intended for individuals under the age of 18. We do not knowingly collect data from children without parental consent.</p>

            <h2>12. International Data Transfer</h2>
            <p>If we transfer personal data outside Switzerland, we ensure that the data is protected with a comparable level of security.</p>

            <h2>13. Changes to This Policy</h2>
            <p>We may update this policy periodically. It's your responsibility to review it regularly.</p>

            <h2>14. Contact</h2>
            <p>For questions, data requests, or any other inquiries related to your privacy, please contact us.</p>

            <h2>15. Jurisdiction</h2>
            <p>This policy is governed by Swiss law. Any disputes arising from this policy will be resolved in Swiss courts.</p>

        </div>
    )
}

export default Main
